import React, { useEffect, useRef, useState } from 'react';
import { FaBell } from 'react-icons/fa';

const NotificationBell = () => {
    const [isOpen, setIsOpen] = useState(false);
    const notificationRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return undefined;

        const handlePointerDown = event => {
            if (notificationRef.current && !notificationRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        const handleKeyDown = event => {
            if (event.key === 'Escape') setIsOpen(false);
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen]);

    return (
        <div className="oi-notification" ref={notificationRef}>
            <button
                type="button"
                className="oi-notification__trigger"
                aria-label="Notifications"
                aria-haspopup="dialog"
                aria-expanded={isOpen}
                aria-controls="notification-panel"
                onClick={() => setIsOpen(open => !open)}>
                <FaBell className="fa-bell" aria-hidden="true" />
                <span className="oi-notification__badge" aria-label="0 unread notifications">
                    0
                </span>
            </button>
            {isOpen && (
                <section
                    className="oi-notification__panel"
                    id="notification-panel"
                    role="dialog"
                    aria-label="Notifications">
                    <h2 className="oi-notification__title">Notifications</h2>
                    <p className="oi-notification__empty">No notifications yet.</p>
                </section>
            )}
        </div>
    );
};

export default NotificationBell;
